import TwoColumnsRectangleAndCircle from "./TwoColumnsRectangleAndCircle";

export default TwoColumnsRectangleAndCircle;
